module.exports = __webpack_public_path__ + "static/media/Mediservice.9a08c098.svg";